import { useCallback, useContext } from 'react';
import { DocumentLandscape20Regular } from '@fluentui/react-icons';
import { Editor } from '@tiptap/core';

import ToolbarButton from './ToolbarButton';
import DocumentContext from '../../../contexts/DocumentContext.context';
import useEditorActive from '../../../hooks/useEditorActive.hook';
import { canInsertLandscapeSection } from '../../../tiptap/nodes/section/commands/canInsertLandscapeSection';

const getTooltip = (e: Editor) => {
  if (e.storage.section?.isLandscape) return 'Document is in landscape mode';
  if (!canInsertLandscapeSection(e)) return 'Cannot insert here';
  return 'Insert landscape page';
};

const LandscapeSectionButton = () => {
  const { editor } = useContext(DocumentContext);

  const handleInsertSection = useCallback(() => {
    editor.chain().focus().insertLandscapeSection().run();
  }, [editor]);

  const tooltip = useEditorActive(getTooltip);

  return (
    <ToolbarButton
      tooltip={tooltip}
      icon={<DocumentLandscape20Regular />}
      onClick={handleInsertSection}
      disabled={(e) => !canInsertLandscapeSection(e)}
    >
      Landscape
    </ToolbarButton>
  );
};

export default LandscapeSectionButton;
